import React from 'react'
import styled from 'styled-components'

import { media } from '../../../styles/media'
import { SubSection } from './shared'
import CancellationPolicy from '../../../components/payment/CancellationPolicy'

const DetailsList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    margin-bottom: 16px;
  }
`

const Detail = styled.li`
  display: block;
  margin-bottom: 16px;

  line-height: 2;

  ${media.lg`
    div {
      display: inline-block;
    }
  `}
`

const DetailLine = styled.div`
  margin-right: 16px;

  &:last-child {
    margin-right: 0;
  }

  ${media.lg`
    & + & {
      &:before {
        content: '\u2219';
        display: inline-block;
        vertical-align: text-top;
        height: 16px;

        margin-right: 16px;

        font-size: 56px;
        line-height: 16px;
      }
    }
  `}
`

export default ({ listing }) => (
  <SubSection>
    <DetailsList>
      {listing.details.map((detail, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Detail key={index}>
          {Object.keys(detail).map((label, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <DetailLine key={i}>
              <div>
                {label} {detail[label]}
              </div>
            </DetailLine>
          ))}
        </Detail>
      ))}
    </DetailsList>
    <div>
      Cancellation Policy:&nbsp;
      <CancellationPolicy
        listing={listing}
        policy={listing.cancellation_policy}
        short
      />
    </div>
    {listing.compliance_number?.length > 0 &&
      !listing.compliance_number_exempt && (
        <div style={{ marginTop: '16px', lineHeight: '2' }}>
          STRA Registration: {listing.compliance_number}
        </div>
      )}
  </SubSection>
)
